import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";

// eslint-disable-next-line react-refresh/only-export-components
export const CargoTankDesign = {
	"*": "*",
	"1": "Pressure cargo tank",
	"2": "Closed cargo tank",
	"3": "Open cargo tank with flame arrester",
	"4": "Open cargo tank",
};

export const ProductCargoTankDesignSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(CargoTankDesign)}
		getOptionLabel={opt => getLabel(opt as keyof typeof CargoTankDesign)}
		multiple={false}
		value={value}
		onChange={onChange}
	/>;
};

function getLabel(cargoTankDesign: keyof typeof CargoTankDesign) {
	return cargoTankDesign === "*" ? "*" : `${cargoTankDesign}. ${CargoTankDesign[cargoTankDesign]}`;
}

// eslint-disable-next-line react-refresh/only-export-components
export function productCargoTankDesignField(cargoTankDesign: keyof typeof CargoTankDesign | undefined) {
	if (!cargoTankDesign) {
		return "-";
	}
	if (cargoTankDesign === "*") {
		return "*";
	}
	return <Tooltip title={CargoTankDesign[cargoTankDesign]} placement="right"><span>{cargoTankDesign}</span></Tooltip>;
}
